import React, { useState } from "react";
import "../assets/css/index.css";
import loadable from "@loadable/component"
import Calculator from '../components/calculator';
import background from "../assets/img/background.webp";
import Swap from "../components/Swap";
import Commisions from "../components/Commisions";
import ContractAudit from "../components/ContractAudit";
import LogoDarlingWaifu from "../components/LogoDarlingWaifu";

const Index = () => {
    return (
        <div className="relative">
            <img src={background} className={`fixed inset-0 w-full h-full bg-cover  `} alt="background" />
            <ContractAudit />
            <LogoDarlingWaifu />
            <div className="min-h-screen flex justify-center items-center relative z-[50]  mt-20">
                <div className="flex flex-wrap  w-11/12 lg:w-10/12">
                    <Swap />
                    <Commisions />
                </div>
            </div>
        </div>

    )
}

export default Index;